import {
  type SalesPartnerBasicData,
  type SalesPartnerBasicDataDTO,
} from "~/domains/salesPartner/types/SalesPartnerTypes";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { normalizeSalesPartnerBasicData } from "./getCompanyList";

function getApiUrl(): string {
  return occUrl("/store-finder/basic-data");
}

export function getBasicSalesPartnerData(): Promise<SalesPartnerBasicData> {
  return occFetch(getApiUrl()).then((response) => {
    if (!response.ok) {
      throw alert("Error status: " + response.status + ", please try again");
    } else {
      return response.json().then((dto: SalesPartnerBasicDataDTO) => normalizeSalesPartnerBasicData(dto));
    }
  });
}
